/* eslint-disable react-native/no-color-literals */
import React, { FC } from 'react';
import { ElementType, exitWalkthrough, goToWalkthroughElementWithId, nullElement } from "react-native-walkthrough"
import { View } from 'native-base';
import { Text } from "../components/text/text"
import { Appearance, Dimensions } from "react-native"
import { Button } from "../components"
import { translate } from "../i18n"
import { getRootStore } from "../utils/root-store"

const Content: FC<{
  colorScheme?: "light"|"dark",
  text: string,
  order?: number,
  total?: number,
  nextText?: string,
  onNext?: () => void
}> = function Content(props) {
  const {
    colorScheme = "light" || Appearance.getColorScheme(),
    text, order, total, nextText, onNext
  } = props

  return <View>
    <Text text={text} preset="textBase" marginBottom="8px" colorScheme={colorScheme} />
    <View flex={1} height="30px" flexDirection="row" alignItems="center" justifyContent="space-between">
      <Text text={`${order}${total ? `/${total}` : ''}`} preset="xs" colorScheme={colorScheme} />
      <Button
        testID="jala:id/next-button"
        text={nextText || translate("common.next")}
        textPreset="caption2"
        preset="primarySmall"
        colorScheme={colorScheme}
        onPress={onNext}
      />
    </View>
  </View>
}

export default (onExit?: () => void) => {
  const width = Dimensions.get('window').width;
  const {
    appStore: { farmStore: { pondStore: { autoFeederPond } } }
  } = getRootStore()

  const isNormalMode = autoFeederPond?.state?.mode === 'normal'

  return [
    {
      id: 'asto-connected-state',
      content: translate("astoCoachmark.connection"),
      placement: 'bottom',
      tooltipProps: {
        tooltipStyle: { left: null, right: 24 },
        arrowStyle: { right: (1.5 * width / 5) - 9 - 24 }
      }
    },
    {
      id: 'asto-today-feed',
      content: translate("astoCoachmark.todayFeed"),
      placement: "top",
    },
    (isNormalMode ? {
      id: 'asto-today-feed-normal',
      content: translate("astoCoachmark.todayFeedNormal"),
      placement: 'bottom',
    } : null),
    {
      id: 'asto-next-day-feed',
      content: translate("astoCoachmark.nextDayFeed"),
      placement: 'top',
    },
  ].filter((v) => v).map((value, index, array) => ({
    ...value,
    tooltipProps: {
      allowChildInteraction: false,
      ...((index < (array.length - 1)) ? {} : { onClose: () => undefined }),
      tooltipStyle: { left: 0, right: 0, marginLeft: 'auto', marginRight: 'auto' },
      ...value.tooltipProps
    },
    content: <Content
      text={value.content}
      order={index + 1}
      total={array.length}
      nextText={!array[index + 1] ? translate('common.done') : undefined}
      onNext={() => {
        if (array[index + 1])
          goToWalkthroughElementWithId(array[index + 1]?.id || nullElement.id)
        else {
          onExit && onExit()
          exitWalkthrough()
        }
      }}
    />
  })) as Array<ElementType>;
}
